/**
 * @generated SignedSource<<9d7c5ff00450ffabd7fadec2325c0a41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetTreeStateHeadInput = {
  clientMutationId?: string | null;
  newHeadContentId: string;
  rootId: string;
  userId: string;
};
export type userRootNodeItemTreeItem_SetTreeStateHeadMutation$variables = {
  input: SetTreeStateHeadInput;
};
export type userRootNodeItemTreeItem_SetTreeStateHeadMutation$data = {
  readonly Admin: {
    readonly LearnV2: {
      readonly setTreeStateHead: {
        readonly treeState: {
          readonly " $fragmentSpreads": FragmentRefs<"userRootNodeItem_TreeStateFragment">;
        };
      } | null;
    };
  };
};
export type userRootNodeItemTreeItem_SetTreeStateHeadMutation = {
  response: userRootNodeItemTreeItem_SetTreeStateHeadMutation$data;
  variables: userRootNodeItemTreeItem_SetTreeStateHeadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userRootNodeItemTreeItem_SetTreeStateHeadMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetTreeStateHeadPayload",
                "kind": "LinkedField",
                "name": "setTreeStateHead",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeState",
                    "kind": "LinkedField",
                    "name": "treeState",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "userRootNodeItem_TreeStateFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userRootNodeItemTreeItem_SetTreeStateHeadMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetTreeStateHeadPayload",
                "kind": "LinkedField",
                "name": "setTreeStateHead",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeState",
                    "kind": "LinkedField",
                    "name": "treeState",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "definition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TreeNode",
                                "kind": "LinkedField",
                                "name": "headContentNode",
                                "plural": false,
                                "selections": (v4/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "StartedTreeStateDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "progressPercentage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "rootNode",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CoordinatesV2",
                                "kind": "LinkedField",
                                "name": "coordinates",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "parentRef",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "childRefs",
                                    "storageKey": null
                                  }
                                ],
                                "type": "BranchTypeDefinition",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentKind",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "elements",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "elementType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isElementV2"
                                          },
                                          (v8/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "question",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "MultipleChoiceElementV2",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ELearningContentTypeDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "ContentTypeDefinition",
                                "abstractKey": "__isContentTypeDefinition"
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TreeUnlockedState",
                                "kind": "LinkedField",
                                "name": "treeUnlockedState",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "kind",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "unlockedByUser",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "UnlockedByAdmin",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "License",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "creationInfo",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "LicenseDefinition",
                                                    "kind": "LinkedField",
                                                    "name": "licenseDefinition",
                                                    "plural": false,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "data",
                                                        "plural": false,
                                                        "selections": [
                                                          (v3/*: any*/),
                                                          (v5/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "UnlockedByLicense",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "when",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentSubmission",
                                "kind": "LinkedField",
                                "name": "submissions",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastUpdated",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "learnOpportunity",
                                    "plural": false,
                                    "selections": (v4/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GamificationPointsReceivedByContent",
                                "kind": "LinkedField",
                                "name": "gamificationPoints",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "num",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TkaTreeStateExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "becd4c404a532481d70ad98a492153fc",
    "id": null,
    "metadata": {},
    "name": "userRootNodeItemTreeItem_SetTreeStateHeadMutation",
    "operationKind": "mutation",
    "text": "mutation userRootNodeItemTreeItem_SetTreeStateHeadMutation(\n  $input: SetTreeStateHeadInput!\n) {\n  Admin {\n    LearnV2 {\n      setTreeStateHead(input: $input) {\n        treeState {\n          ...userRootNodeItem_TreeStateFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ElementNode_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  id\n  title\n  ... on MultipleChoiceElementV2 {\n    question\n  }\n  elementType\n}\n\nfragment treeUnlockedStateDisplay_TreeUnlockedStateFragment on TreeUnlockedState {\n  when\n  data {\n    __typename\n    kind\n    ... on UnlockedByAdmin {\n      unlockedByUser {\n        id\n        name\n      }\n    }\n    ... on UnlockedByLicense {\n      license {\n        id\n        creationInfo {\n          __typename\n          licenseDefinition {\n            id\n            data {\n              __typename\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment userRootNodeItem_TreeStateFragment on TreeState {\n  id\n  definition {\n    __typename\n    status\n    ... on FinishedTreeStateDefinition {\n      status\n    }\n    ... on StartedTreeStateDefinition {\n      status\n      headContentNode {\n        id\n      }\n    }\n  }\n  user {\n    name\n    id\n  }\n  startedAt\n  progressPercentage\n  rootNode {\n    parentId\n    structureDefinition {\n      __typename\n      coordinates {\n        parentRef\n      }\n      definitionType\n      title\n    }\n    typeDefinition {\n      __typename\n      definitionType\n      ... on BranchTypeDefinition {\n        childRefs\n      }\n      ... on ContentTypeDefinition {\n        __isContentTypeDefinition: __typename\n        contentKind\n        ... on ELearningContentTypeDefinition {\n          elements {\n            __typename\n            id\n            elementType\n            ...ElementNode_ElementV2Fragment\n          }\n        }\n      }\n    }\n    id\n  }\n  extension {\n    __typename\n    ... on TkaTreeStateExtension {\n      treeUnlockedState {\n        data {\n          __typename\n          kind\n        }\n        ...treeUnlockedStateDisplay_TreeUnlockedStateFragment\n        id\n      }\n      submissions {\n        id\n        startedAt\n        lastUpdated\n        learnOpportunity {\n          id\n        }\n      }\n      gamificationPoints {\n        id\n        contentId\n        num\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d600d3745303073cd72f4a0460410219";

export default node;
